import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { CHECKOUT_URL, previewImages } from '../data/hvac';
export function PreviewCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(previewImages.length - 1, i));
    const slide = track.children[clamped] as HTMLElement | undefined;
    if (slide) {
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
    }
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const width = track.clientWidth;
      if (width === 0) return;
      setIndex(Math.round(track.scrollLeft / width));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-navy px-4 py-5 sm:py-7" data-id="element-120" data-mp="3am5apxfq3tfd">
      <div className="mx-auto max-w-3xl" data-id="element-121" data-mp="3amx7hbl23x78">
        <p className="text-center text-[10px] font-extrabold uppercase tracking-[0.2em] text-diag sm:text-xs" data-id="element-122" data-mp="3fl8gjk3j23oe">
          Preview the material
        </p>
        <h2 className="mt-1 text-center text-xl leading-tight text-white sm:text-3xl" data-id="element-123" data-mp="3kcqgq5xq808b">
          Take a Look Inside HVAC DIAGNOSTIC READY™
        </h2>
        <p className="mx-auto mt-1.5 max-w-2xl text-center text-sm font-medium leading-snug text-white/85" data-id="element-124" data-mp="3tcn320wn8n07">
          Explore the visual diagnostic maps, troubleshooting flows, component references,
          testing pathways, pressure patterns and ready-to-use field resources included
          throughout the complete system.
        </p>

        <div className="relative mt-3" data-id="element-125" data-mp="23z0buwys97xm">
          <ul ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory gap-3 overflow-x-auto scroll-smooth" aria-label="Preview of pages inside HVAC DIAGNOSTIC READY" data-id="element-126" data-mp="2401mx1fstufc">
            {previewImages.map(image => <li key={image.src} className="w-full shrink-0 snap-center" data-id="element-127" data-mp="1vykanr13dmxx">
                <a href={CHECKOUT_URL} className="block" data-id="element-128" data-mp="2avba20armynj">
                  <img src={image.src} alt={image.alt} loading="lazy" className="mx-auto w-full rounded-lg border-2 border-white/70 bg-white shadow-2xl" data-id="element-129" data-mp="25v6rm4qartuo" />
                </a>
              </li>)}
          </ul>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-hvac hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-130" data-mp="2tlaweff81zn9">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-131" data-mp="3h8o6t33klx2b" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === previewImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/95 text-navy shadow-lg transition-colors duration-150 hover:bg-hvac hover:text-white disabled:pointer-events-none disabled:opacity-0" data-id="element-132" data-mp="3m5y7jewetv5g">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-133" data-mp="2ph8ohl91qwhw" />
          </button>
        </div>

        <div className="mt-2 flex items-center justify-center gap-2" data-id="element-134" data-mp="2ti2bmceo079q">
          {previewImages.map((image, i) => <button key={image.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1} of ${previewImages.length}`} aria-current={i === index} className={`h-2 rounded-full transition-[width,background-color] duration-200 ease-soft ${i === index ? 'w-6 bg-diag' : 'w-2 bg-white/40 hover:bg-white/70'}`} data-id="element-135" data-mp="2fju7nkj7o5p2" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}